import { Group } from 'business';
import { useBatchedQuery } from 'bridge';

export default function useGroups(userId?: string) : [Group[] | undefined, () => void]  {
    const [groups, onLoadMoreGroups] = useBatchedQuery<Group>({ userId: userId, queryType: 'groupsMine'});
    return [groups, onLoadMoreGroups];
}
